module.exports = __webpack_public_path__ + "media/images/platforms/ea-id/square-bace7af9971050ca13e29818913c20de.jpg";